import React from 'react'
import PropTypes from 'prop-types'
import {reduxForm, Field} from 'redux-form'
import {Button, Tooltip, ClearIcon} from 'rambler-ui'
import GeoField from 'components/GeoField'
import RowButton from 'components/RowButton'
import InlineForm from 'components/InlineForm'

function ChangeGeo({submitting, buttonTooltip, onClose, handleSubmit}) {
  return (
    <InlineForm onSubmit={handleSubmit}>
      <Field
        placeholder="Населенный пункт"
        component={GeoField}
        name="geoid"
        autoFocus
        autoComplete={false}
      />
      <Tooltip
        position="bottom"
        content={buttonTooltip}
        isOpened={!!buttonTooltip}>
        <Button
          type="primary"
          buttonType="submit"
          tabIndex="0"
          loading={submitting}
          disabled={submitting}>
          Сохранить
        </Button>
      </Tooltip>
      <RowButton label="Закрыть" onClick={onClose}>
        <ClearIcon />
      </RowButton>
    </InlineForm>
  )
}

ChangeGeo.propTypes = {
  submitting: PropTypes.bool,
  buttonTooltip: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired
}

export default reduxForm({form: 'changeGeo'})(ChangeGeo)
